import { IJsonQuery } from '@cian/api-models/common/json_query';

import { NonEmptyArray } from './types/common';
import { EFacilityType } from './types';
import { getTermValue } from './helpers';

export function getSuburbanFacilityTypes(jsonQuery: IJsonQuery): NonEmptyArray<EFacilityType> | null {
  const hasSauna = getTermValue('bathhouse')(jsonQuery);
  const hasGarage = getTermValue('garage')(jsonQuery);
  const hasSecurity = getTermValue('security')(jsonQuery);
  const hasPool = getTermValue('pool')(jsonQuery);

  const facilityTypes: EFacilityType[] = [];

  if (hasSauna) {
    facilityTypes.push(EFacilityType.Sauna);
  }

  if (hasGarage) {
    facilityTypes.push(EFacilityType.Garage);
  }

  if (hasSecurity) {
    facilityTypes.push(EFacilityType.Security);
  }

  if (hasPool) {
    facilityTypes.push(EFacilityType.Pool);
  }

  return facilityTypes.length > 0 ? (facilityTypes as NonEmptyArray<EFacilityType>) : null;
}
